import type RiskIndicatorsGroup from "@/models/risk-widgets/riskIndicatorsGroup";

export class FlagsDto {
  riskIndicatorsGroups: RiskIndicatorsGroup[] =
    new Array<RiskIndicatorsGroup>();
  countryCodes: Array<string> = new Array<string>();
  suppliersWithDisclosedBreaches: number = 0;
}
